<template>
  <custom-callout border-color="orange" class="mb-4 shadow" :has-toggle="false">
    <validation-observer ref="invoiceForm" novalidate tag="form">
      <icon-view
        id="icon-invoice"
        icon="fa fa-file-invoice"
        icon-background="#fff"
        icon-color="#f87058"
        icon-size="16px"
        title="Crear Nueva Factura"
      />
      <div class="row">
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="academicYear"
              v-model="valueModel.academicYear"
              :clearable="false"
              custom-error-msg="Favor de seleccionar el año fiscal."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Año Académico:"
              :options="academicYearOptions"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="month"
              v-model="valueModel.month"
              :clearable="false"
              custom-error-msg="Favor de seleccionar un mes."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Mes:"
              :options="monthOptions"
              placeholder="Seleccione el mes"
            />
          </validation-provider>
        </div>
        <div v-if="!isProvider" class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="provider"
              v-model="valueModel.provider"
              :clearable="false"
              custom-error-msg="Favor de seleccionar un proveedor."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Proveedor:"
              :options="providerOptions"
              placeholder="Seleccione Proveedor"
            />
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="center"
              v-model="valueModel.center"
              :clearable="false"
              custom-error-msg="Favor de seleccionar un centro."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Centro:"
              :options="centerOptions"
              placeholder="Seleccione el Centro"
            />
          </validation-provider>
        </div>
        <div
          class="col-md-3 text-right pt-4"
          :class="{ 'col-md-12': !isProvider, 'pt-4': isProvider }"
        >
          <action-button
            id="cancel-btn"
            i="fas fa-times-circle"
            variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
            @click="$emit('cancel')"
          >
            Cancelar
          </action-button>
          <action-button
            id="success-btn"
            i="fas fa-arrow-circle-right"
            variant="success pl-4 pr-4"
            @click="create"
          >
            Continuar
          </action-button>
        </div>
      </div>
    </validation-observer>
  </custom-callout>
</template>

<script>
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'InvoiceForm',
  components: {
    IconView,
    ActionButton,
    CustomCallout,
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        academicYear: null,
        month: null,
        provider: null,
        center: null,
      }),
    },
    isProvider: {
      type: Boolean,
      default: false,
    },
    academicYearOptions: {
      type: Array,
      default: () => [],
    },
    monthOptions: {
      type: Array,
      default: () => [],
    },
    providerOptions: {
      type: Array,
      default: () => [],
    },
    centerOptions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    valueModel: {
      academicYear: null,
      month: null,
      provider: null,
      center: null,
    },
  }),
  watch: {
    valueModel: {
      deep: true,
      handler(newValue) {
        this.$emit('input', newValue);
      },
    },
    'valueModel.academicYear'() {
      this.valueModel.month = null;
      this.valueModel.provider = null;
    },
    value: {
      deep: true,
      handler(newValue) {
        Object.assign(this.valueModel, newValue);
      },
    },
  },
  methods: {
    async create() {
      const isValid = await this.$refs.invoiceForm.validate();
      if (isValid) {
        this.$emit('create', this.valueModel);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
